import { LoginInfo } from '@/interfaces/LoginInterface';
import storage from 'good-storage';

export interface CacheUtilType {
    setLoginInfo: (loginInfo: LoginInfo) => LoginInfo;
    getLoginInfo: () => LoginInfo;
    clearLoginInfo: () => void;
}

const initialLoginInfo: LoginInfo = {
    id: 99999,
    user_name: '',
    real_name: '',
    role_id: 99999,
    token: '',
    status: '',
    msg: '',
};

export const HAP_LOGIN_INFO = 'HAPLoginInfo';
export const CacheUtil: CacheUtilType = {
    setLoginInfo: (loginInfo) => {
        storage.set(HAP_LOGIN_INFO, loginInfo);
        return loginInfo;
    },
    getLoginInfo: () => {
        const loginInfo = storage.get(HAP_LOGIN_INFO);
        return loginInfo ? loginInfo : initialLoginInfo;
    },
    clearLoginInfo: () => {
        storage.remove(HAP_LOGIN_INFO);
    },
};
